import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";

export class FaQModel {
    faqId : string;
    faqNo : number;
    categoryId : string;
    productId : string;
    issue : string;
    solution : string;
    createTime :  DatePipe;
    createBy : string;
    ifiles : string[];
    sfiles : string[];

    public static getFormGroup()
    {
        var form = new FormGroup({
            faqId: new FormControl(null),
            faqNo: new FormControl(null),
            categoryId : new FormControl(null),
            productId: new FormControl(null),
            issue : new FormControl('', Validators.required),
            solution : new FormControl('', Validators.required),
            createBy : new FormControl(null),
            createTime : new FormControl(null),
        });

        return form;

    }

    public static initializeFormGroup(form){
   
        return form.setValue({
            faqId: null,
            faqNo: null,
            categoryId : null,
            productId: null,
            issue : null,
            solution : null,
            createBy : null,
            createTime : null,
        });
      
    }

    public static populateForm(form, item : FaQModel) {
        return form.setValue(item);
    }
}